import { render, staticRenderFns } from "./configOptionTableModal.vue?vue&type=template&id=c459b15c&scoped=true"
import script from "./configOptionTableModal.vue?vue&type=script&lang=js"
export * from "./configOptionTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c459b15c",
  null
  
)

export default component.exports